import React from "react";

const TitleText = ({ text = "Section Title" }) => {
  return (
    <h1 className="font-semibold lg:w-fit text-lg text-left text-[20px] sm:text-[22px] lg:text-[24px] text-textPrimaryColor">
      {text}
    </h1>
  );
};

export default TitleText;
